import { useState } from 'react'

export const Alert = ({ type, title, children, className }: AlertProps) => {
  const [isVisible, setIsVisible] = useState(true)
  const [isFading, setIsFading] = useState(false)

  const typeStyles = {
    success: {
      bg: 'bg-green-100',
      border: 'border-green-500',
      text: 'text-green-700',
    },
    info: {
      bg: 'bg-blue-100',
      border: 'border-blue-500',
      text: 'text-blue-700',
    },
    error: {
      bg: 'bg-red-100',
      border: 'border-red-500',
      text: 'text-red-700',
    },
  }

  const { bg, border, text } = typeStyles[type]

  const handleClose = () => {
    setIsFading(true) // Start fade-out animation
    setTimeout(() => setIsVisible(false), 800) // Remove from DOM after animation
  }

  if (!isVisible) return null

  return (
    <div
      className={`${bg} mx-auto border-l-4 ${border} ${text} p-4 rounded-lg shadow-md mb-4 relative transition-opacity ease-in-out ${
        isFading ? 'opacity-0 duration-700' : 'opacity-100 duration-500'
      } ${className || ''}`}
    >
      <button
        onClick={handleClose}
        className="absolute top-2 right-4 text-lg font-bold text-gray-600 hover:text-gray-800"
        aria-label="Close alert"
      >
        ×
      </button>
      {title && <h2 className="text-3xl font-bold mb-2">{title}</h2>}
      <div className="text-lg">{children}</div>
    </div>
  )
}

interface AlertProps {
  type: 'success' | 'info' | 'error'
  title?: string
  children: React.ReactNode
  className?: string
}
